<!-- Unified responsive navigation card -->
@let cfg = config();

<!-- Internal link (Angular routing) -->
@if (!cfg.isExternalLink) {
  <a
    [routerLink]="cfg.routerLink"
    class="group block h-full focus:outline-none"
    [attr.data-testid]="cfg.testId"
    [attr.aria-label]="cfg.title ? (cfg.title | translate) : cfg.ariaLabel"
  >
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
  </a>
}

<!-- External link -->
@if (cfg.isExternalLink) {
  <a
    [href]="cfg.routerLink"
    class="group block h-full focus:outline-none"
    [attr.data-testid]="cfg.testId"
    [attr.aria-label]="cfg.title ? (cfg.title | translate) : cfg.ariaLabel"
  >
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
  </a>
}

<!-- Card content template -->
<ng-template #cardContent>
  <div
    class="relative shadow-sm transition-all duration-300 group-hover:shadow-xl h-full rounded-2xl p-6 sm:rounded-3xl sm:p-8 sm:group-hover:-translate-y-2 group-focus-visible:ring-2"
    [class.border]="!cfg.backgroundColor"
    [class.border-gray-100]="!cfg.backgroundColor"
    [class.group-hover:border-emerald-200]="!cfg.backgroundColor"
    [class.group-focus-visible:ring-emerald-500]="!cfg.backgroundColor"
    [class.group-focus-visible:ring-gray-900]="!!cfg.backgroundColor"
    [style.background-color]="cfg.backgroundColor ?? 'white'"
  >
    <!-- Gradient background effect (desktop only) -->
    <!-- Emerald gradient for white background -->
    @if (!cfg.backgroundColor) {
      <div
        class="absolute inset-0 bg-gradient-to-br from-emerald-500/0 to-emerald-500/5 opacity-0 group-hover:opacity-100 transition-all duration-300 rounded-2xl sm:rounded-3xl"
      ></div>
    }
    <!-- Dark overlay for custom background colors -->
    @if (cfg.backgroundColor) {
      <div
        class="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300 rounded-2xl sm:rounded-3xl"
      ></div>
    }

    <!-- Card content -->
    <div
      class="relative z-10 flex items-center h-full space-x-4 sm:space-x-4"
      [class.justify-center]="!cfg.title"
    >
      <!-- Icon with badge support -->
      <div class="relative flex items-center">
        @if (cfg.iconName) {
          <mat-icon
            [svgIcon]="cfg.iconName"
            [class]="'w-8 h-8 sm:w-12 sm:h-12'"
            [attr.aria-hidden]="true"
          />
        } @else {
          @if (cfg.iconSrc) {
            <img
              [src]="cfg.iconSrc"
              [class]="'w-8 h-8 sm:w-12 sm:h-12'"
              [alt]="''"
              aria-hidden="true"
            />
          }
        }

        <!-- Badge -->
        @if (cfg.badgeCount != null) {
          <div
            class="absolute text-xs flex justify-center items-center bg-orange-600 text-white rounded-full -top-1 -right-1 w-5 h-5 sm:-top-2 sm:-right-2 sm:w-6 sm:h-6"
            role="status"
            [attr.aria-label]="cfg.badgeCount + ' ' + ('ALERT_NOTIFICATIONS.UNREAD' | translate)"
          >
            <span aria-hidden="true">{{ cfg.badgeCount | notificationsCounter }}</span>
          </div>
        }
      </div>

      <!-- Title -->
      @if (cfg.title) {
        <div class="flex-1">
          <h3
            class="font-bold transition-colors duration-300 text-lg sm:text-base sm:font-semibold"
            [class.text-gray-900]="!cfg.backgroundColor"
            [class.text-white]="cfg.backgroundColor"
            [class.group-hover:text-emerald-900]="!cfg.backgroundColor"
          >
            {{ cfg.title | translate }}
          </h3>
        </div>
      }

      <!-- Arrow icon (mobile only) -->
      @if (cfg.title) {
        <div
          class="ml-4 sm:hidden"
          aria-hidden="true"
        >
          <svg
            class="w-5 h-5 transition-colors duration-300"
            [class.text-gray-400]="!cfg.backgroundColor"
            [class.group-hover:text-emerald-500]="!cfg.backgroundColor"
            [class.text-black]="cfg.backgroundColor"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            ></path>
          </svg>
        </div>
      }
    </div>
  </div>
</ng-template>
